import { TranscriptSignalMetricRecord } from "./TranscriptSignalMetricRecord"

export class UserFrustrationMetricRecord extends TranscriptSignalMetricRecord {}
